import React from 'react';
import PropTypes from 'prop-types';

import {getQASummary} from '../upload/utils';


export default class Summary extends React.Component {

  static propTypes = {
    rawDataCollection: PropTypes.object.isRequired,
  };

  get isolateInfo() {
    const {rawDataCollection} = this.props;
    const {rawSequences} = rawDataCollection;

    const isolates = new Set();
    const patients = new Set();

    for (const seq of rawSequences) {
      const patient = seq.ptAlias;
      const isolateDate = seq.isolateDate;
      const isolateName = seq.isolateName;
      if (patient) {
        patients.add(patient);
      }

      // TODO, isolate count by isolate name
      if (patient === 'LabStrain') {
        isolates.add(isolateName);
      } else if (patient && isolateDate) {
        const isolate = `${patient}-${isolateDate}`;
        isolates.add(isolate);
      }
    }

    const {seqType} = rawDataCollection;
    const isClinical = !seqType || seqType === 'ClinicalList';

    return (
      <p>
        {isClinical? <span>
          Patients ({patients.size});{' '}
        </span> : null}
        <span>
          Samples ({isolates.size});{' '}
        </span>
      </p>
    );
  }

  get sequenceGeneInfo() {
    const {rawDataCollection} = this.props;
    const {rawAlignments} = rawDataCollection;

    const summary = rawAlignments.reduce((accu, aligned) => {
      for (const gene of aligned.geneSequences) {
        const geneName = gene.gene;
        accu[geneName] = (geneName in accu) ? accu[geneName] : 0;
        accu[geneName] += 1;
      }
      return accu;
    }, {});

    const spliter = ';' + ' ';
    const summary_length = Object.entries(summary).length;

    return (
      <span>
        {Object.entries(summary).map(([geneName, number], idx) => {
          const showSpliter = (idx < (summary_length - 1));
          return (
            <span key={idx}>
              {geneName}{' '}({number})
              {showSpliter? spliter: null}
            </span>
          );
        })}
      </span>
    );
  }

  get sequenceCloneInfo() {
    const {rawDataCollection} = this.props;
    const {rawSequences} = rawDataCollection;

    const cloneSeq = rawSequences.filter((seq) => {
      return seq.cloneName && seq.cloneName !== '';
    });

    const cloneSeqLength = cloneSeq.length;

    if (cloneSeqLength === 0) {
      return null;
    }

    return (
      <p>
        Cloned: {cloneSeqLength}
      </p>
    );
  }


  render() {
    const {rawDataCollection} = this.props;

    return (
      <div>
        <h3>
          Sequence data summary:
        </h3>
        {this.isolateInfo}
        <p>
          {this.sequenceGeneInfo}
        </p>
        {this.sequenceCloneInfo}

        <div>
          {getQASummary(rawDataCollection)}
        </div>

        <hr/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/gtable_iso/summary.js